<template>
  <div class="container ">
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li aria-current="page" class="breadcrumb-item active">Select Employee</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-4">
            <label>Employee Name</label>
            <multiselect v-model="employee" tag-placeholder="Search employee" placeholder="Search employee" label="name"
              track-by="name" :options="employeeOptions" :multiple="false" :max-height="200">
            </multiselect>
          </div>
          <div class="col-12 mt-10">
            <button class="btn btn-primary col-1" @click="getAllTimeSheet">Search</button>
            <button class="btn btn-light col-1" @click="resetSearchForm">Reset</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-30 mb-5">
      <div class="col-12 text-right">
        <router-link :to="'/timesheet/add/'+employee.uuid" tag="button" class="btn btn-primary col-1" v-if="employee">Add</router-link>
      </div>
    </div>
    <div class="card my-10">
      <div class="card-body p-0">
        <table class="table table-striped">
          <thead>
            <th class="text-page">Employee Name</th>
            <th class="text-page">Timesheet Period</th>
            <th class="text-center text-page">Actions</th>
          </thead>
          <tbody>
            <tr v-for="(AllTimeSheet, index) in AllTimeSheets" :key="index">
              <td class="text-page">{{ AllTimeSheet.employee.name }}</td>
              <td class="text-page">
                {{ AllTimeSheet.start_date }} to {{ AllTimeSheet.end_date }}
              </td>
              <td class="text-center">
                <router-link :to="'/timesheet/edit/' + AllTimeSheet.employee.uuid + '/' + AllTimeSheet.id"  tag="span" style="cursor: pointer;">
<!--                  {{ AllTimeSheet.id }}-->
                  <i class="ico ico-pencil"> </i>
                </router-link>
                <router-link :to="'/timesheet/view/' + AllTimeSheet.employee.uuid+ '/' + AllTimeSheet.id" tag="span" style="cursor: pointer;">View</router-link>
              </td>
            </tr>
            <tr v-if="!AllTimeSheets.length">
              <td colspan="5" class="text-center text-page">No data found.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<style scoped>
.table tr {
  border: none !important;
}

.table thead {
  background-color: #E9E9E9 !important;
}

.table thead th {
  border: none !important;
}

.table-striped>tbody>tr:nth-child(odd)>td,
.table-striped>tbody>tr:nth-child(odd)>th {
  background-color: #F7F7F7;
}

.text-page {
  font-size: 15px !important;
}

body {
  font-family: "Lato", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

input[type=text] {
  border-color: rgb(196, 196, 196) !important;
}
</style>
<script>
import Multiselect from "vue-multiselect";
import Header from "../common/header";
import Swal from "sweetalert2";

export default {
  name: "timesheetProjects",
  components: {
    Header,
    Multiselect,
    Swal
  },
  data() {
    return {
      company_id        : this.$store.getters.getSelectedCompany.id,
      employee          : null,
      AllTimeSheets     : [],
      employeeOptions   : [],
      selected          : [],
      showSearchButton  : false,
    }
  },
  computed: {
    selectAll: {
      get: function () {
        return this.projects ? this.selected.length == this.projects.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.projects.forEach(function (user) {
            selected.push(user.id);
          });
        }
        this.selected = selected;
      }
    }
  },
  mounted() {
    this.getAllTimeSheet();
    // this.getEmployee();
    let employeeOptions=JSON.parse(localStorage.getItem('companyEmployees'));
    if (employeeOptions != null) {
      this.employeeOptions=employeeOptions;
    } else {
      this.getEmployees(); // Fetch employees if not available in localStorage
    }
  },
  methods: {
    async getEmployees() {
      this.loadingSpin = true;
      this.$axios({
        method    : "get",
        params    : {
          company_id  : this.$store.getters.getSelectedCompany.id,
          filter_by   : "EMPLOYEE",
        },
        url     : this.$GetEmployees,
        headers : this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          localStorage.setItem('companyEmployees', JSON.stringify(res.data.message.totalEmployees));
          this.employeeOptions=res.data.message.totalEmployees;
        }
      });
    },
    getAllTimeSheet(id = null) {
      if (this.employee != null) {
        id = this.employee.id;
      }
      let params = {
        employee_id: id,
        company_id: this.company_id,
      };
      this.$axios.get(this.$getTimeSheetAll, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.AllTimeSheets = res.data.result;
          this.showSearchButton = (this.AllTimeSheets.length == 0)?true:false;
        }
      });

    },

    // get Employee for TimeSheet
    getEmployee() {
      let params = {
        company_id: this.company_id,
      };

      this.$axios.get(this.$getEmployee, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.employeeOptions = res.data.result;
        }
      });
    },

    // close modal and reset form
    closeModal() {
      this.resetForm();
      $('#projectModal').modal('hide');
    },

    // reset form data
    resetForm() {
      this.pName = null;
      this.selectedCustomer = null;
      this.selectedAdmins = [];
    },

    // submit form
    submitForm() {
      let admins = [];
      this.selectedAdmins.forEach(function (admin) {
        admins.push(admin.id);
      });
      let formData = {
        name: this.pName,
        status: 1,
        company_id: this.company_id,
        customer_id: (this.selectedCustomer != null) ? this.selectedCustomer.id : null,
        admins: admins
      };
      this.$axios.post(this.$AddProject, formData, {
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.resetForm();
          $('#projectModal').modal('hide');
          this.getProjects();
        }
      });
    },

    editProject(id) {
      let project = this.projects.filter(function (item) {
        return item.id === id;
      });

      if (project.length > 0) {
        this.modalTitle = "Edit Project";
        this.pName = project[0].name;
        this.selectedCustomer = {
          id: project[0].customer.id,
          name: project[0].customer.name
        };
        let admins = [];
        project[0].admins.forEach(function (admin) {
          admins.push({
            name: admin.name,
            id: admin.id
          });
        });
        this.selectedAdmins = admins;
        $('#projectModal').modal('show');
      }
    },

    deleteProjects() {
      new Swal({
        title: "Delete Projects?",
        icon: "warning",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          this.$axios.delete(this.$DeleteProject, {
            params: {
              projects: this.selected
            },
            headers: this.getAuthHeader(),
          }).then(res => {
            if (res.data.status === 200) {
              this.getProjects();
            }
          });
        }
      });
    },

    resetSearchForm() {
      this.employee = null;
      this.getAllTimeSheet()
    }
  }
}
</script>
